import { render } from "./TipTapMentionList.vue?vue&type=template&id=2993d5a8"
import script from "./TipTapMentionList.vue?vue&type=script&lang=js"
export * from "./TipTapMentionList.vue?vue&type=script&lang=js"

import "./TipTapMentionList.vue?vue&type=style&index=0&id=2993d5a8&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__